import { useContext, JSX } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {Handle, Position, useReactFlow, ReactFlowInstance, Node } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowHumanNode({id, data}: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();

    function handleShowHumanConfigurationClick(): void {
        const node: Node = reactFlowInstance.getNode(id);
        context.setActiveEditHumanNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    let conditionalExit: boolean = false;
    if (data?.conditional_exit && data?.conditional_exit === true) {
        conditionalExit = true;
    }

    return (
        <div className={ "workflow-node human " + id + " "  + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="human-node-target" position={ Position.Top } >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Human Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ handleShowHumanConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            { (conditionalExit === true) &&
                <>
                    <Handle type="source"
                            id="human-node-source-fail"
                            style={ { left: '25%' } }
                            position={ Position.Bottom } >
                        <span className="handle-label bottom" >{ "Fail" }</span>
                    </Handle>
                    <Handle type="source"
                            id="human-node-source-continue"
                            style={ { left: '75%' } }
                            position={ Position.Bottom } >
                        <span className="handle-label bottom" >{ "Continue" }</span>
                    </Handle>
                </>
            }
            { (conditionalExit === false) &&
                <Handle type="source"
                        id="human-node-source"
                        position={ Position.Bottom } >
                    <span className="handle-label bottom" >{ "Output" }</span>
                </Handle>
            }

        </div>
    );
}

export default WorkflowHumanNode;